import Wrapper from "../../../layout/Wrapper";
import VehicleBrandManageComponent from "../../../screens/settings/vehicle-brand/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Vehicle Brand Management",
	description: "",
};

export default function VehicleBrandManagement() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleBrandManageComponent />
		</Wrapper>
	);
}